<div class="public-page redirect-page">
    <div class="public-container public-container_transparent">
        <div class="public-page-h1 public-page-h1_text-align_center">
            Перенаправляем вас на страницу с&nbsp;инструкцией для привязки карты к Mirpay
        </div>

        <div class="text-block text-block_text-align_center text-block_margin-bottom_32">
            <div class="text-block__simple-text">
                Если страница автоматически не открылась, перейдите на <a href="https://mironline.ru/mirpay" rel="noreferrer noopener" target="_blank">mironline.ru/mirpay</a>
            </div>
        </div>
        <div class="text-block text-block_text-align_center">
            <div class="text-block__simple-text"><strong>{{counter}}</strong></div>
        </div>
    </div>
</div>
